export default __webpack_public_path__ + "static/media/park-area-gray.c497119f.svg";